import type { Module } from 'vuex';
import { CountryLanguage } from '@/types/CountryLanguage';
import {RootState} from "@/store";

export interface CountryLanguagesState {
  countryLanguages: CountryLanguage[];
}

const countryLanguagesModule: Module<CountryLanguagesState, RootState> = {
  namespaced: true,
  state: (): CountryLanguagesState => ({
    countryLanguages: [],
  }),
  mutations: {
    setCountryLanguages(state, payload: { countryLanguages: Record<string, any> }) {
      state.countryLanguages = [];
      Object.keys(payload.countryLanguages).forEach(countryId => {
        Object.keys(payload.countryLanguages[countryId]).forEach(languageId => {
          const raw = payload.countryLanguages[countryId][languageId];
          state.countryLanguages.push(CountryLanguage.fromRaw(raw));
        });
      });
    },
    setCountryLanguagesCreate(state, payload: any) {
      state.countryLanguages.push(CountryLanguage.fromRaw(payload));
    },
    setCountryLanguagesUpdate(state, payload: any) {
      const idx = state.countryLanguages.findIndex(
        cl => cl.idCountry === Number(payload.idCountry) && cl.idLanguage === Number(payload.idLanguage)
      );
      if (idx !== -1) {
        state.countryLanguages[idx] = { ...state.countryLanguages[idx], ...payload };
      }
    },
    setCountryLanguagesDelete(state, payload: { idCountry: number; idLanguage: number }) {
      state.countryLanguages = state.countryLanguages.filter(
        cl => !(cl.idCountry === Number(payload.idCountry) && cl.idLanguage === Number(payload.idLanguage))
      );
    },
    setCountryLanguagesLock(state, payload: { idCountry: number; idLanguage: number }) {
      const cl = state.countryLanguages.find(
        cl => cl.idCountry === Number(payload.idCountry) && cl.idLanguage === Number(payload.idLanguage)
      );
      if (cl) cl.locked = true;
    },
    setCountryLanguagesUnlock(state, payload: { idCountry: number; idLanguage: number }) {
      const cl = state.countryLanguages.find(
        cl => cl.idCountry === Number(payload.idCountry) && cl.idLanguage === Number(payload.idLanguage)
      );
      if (cl) cl.locked = false;
    },
  },
  actions: {
    wsCountryLanguages({ commit }, payload) {
      commit('setCountryLanguages', payload);
    },
    wsCountryLanguagesCreate({ commit }, payload) {
      commit('setCountryLanguagesCreate', payload);
    },
    wsCountryLanguagesUpdate({ commit }, payload) {
      commit('setCountryLanguagesUpdate', payload);
    },
    wsCountryLanguagesDelete({ commit }, payload) {
      commit('setCountryLanguagesDelete', payload);
    },
    wsCountryLanguagesLock({ commit }, payload) {
      commit('setCountryLanguagesLock', payload);
    },
    wsCountryLanguagesUnlock({ commit }, payload) {
      commit('setCountryLanguagesUnlock', payload);
    },
  },
};

export default countryLanguagesModule;